import { render, staticRenderFns } from "./scheduleDetails.vue?vue&type=template&id=a58da80a&scoped=true"
import script from "./scheduleDetails.vue?vue&type=script&lang=js"
export * from "./scheduleDetails.vue?vue&type=script&lang=js"
import style0 from "./scheduleDetails.vue?vue&type=style&index=0&id=a58da80a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58da80a",
  null
  
)

export default component.exports